import React from "react";
import ReactDOM from "react-dom";
import StripePaymentProvider from "./Stripe/StripeProvider";
import PaymentIframe from "./PayByCard";
import PageLoader from "../Utils/PageLoader";
import Overlay from "../Utils/Overlay";

const PaymentService = ({
  type,
  onClose = () => { },
  setLoading = () => { },
  isStripeSetup = false,
  stripeRedirectUrl,
  stripeClientSecret,
  cardPaymentUrl,
  loading,
  onPaymentFail = () => { },
  onPaymentComplete = () => { },
  loadingMessage = "we're getting your payment form ready",
}) => {
  const handleClose = () => {
    setLoading(false);
    onClose();
  };

  return (
    <React.Fragment>
      {type === "stripe" ? (
        <StripePaymentProvider
          clientSecret={stripeClientSecret}
          close={handleClose}
          setLoading={setLoading}
          redirectUrl={stripeRedirectUrl}
          isSetup={isStripeSetup}
          onPaymentFail={onPaymentFail}
        />
      ) : (
        <PaymentIframe
          url={cardPaymentUrl}
          close={handleClose}
          setLoading={setLoading}
          loading={loading}
          onPaymentComplete={onPaymentComplete}
          type={type}
        />
      )}
      {loading &&
        ReactDOM.createPortal(
          <div className="payment-service-loader">
            <Overlay darkTheme={true} handleOnClick={handleClose} />
            <PageLoader
              title="Hang Tight"
              message={loadingMessage}
              close={handleClose}
            />
          </div>,
          document.body
        )}
    </React.Fragment>
  );
};

export default PaymentService;
